export const dateFilterKeys = ['invitationDateFrom', 'invitationDateTo', 'activationDateFrom', 'activationDateTo']
